import React from 'react';
import Chart from 'react-google-charts'; // eslint-disable-line no-unused-vars

export default class HourStatsComponent extends React.Component {
  render() {
    if (this.props.hourStats.length === 0) {
      return null;
    }

    return (
      <div>
        <Chart
          chartType="AreaChart"
          loader={<div>Loading Chart</div>}
          data={this.props.hourStats}
          options={{
            chartArea: {
              width: this.props.chartWidth,
              height: this.props.chartHeight,
              top: '5',
              left: '5%',
            },
            width: '100%',
            height: this.props.height,
            legend: 'none',
            series: {
              0: { targetAxisIndex: 1 },
            },
            vAxis: {
              viewWindowMode: 'explicit',
              viewWindow: {
                min: 0,
              },
            },
            hAxis: {
              textStyle: {
                fontSize: 8,
              },
            },
          }}
        />
      </div>
    );
  }
}
